'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var LOCATION_POP = exports.LOCATION_POP = 'REDUX-LOCATION-POP-ACTION';
var LOCATION_PUSH = exports.LOCATION_PUSH = 'REDUX-LOCATION-PUSH-ACTION';
var OBJECT_KEY_DELIMITER = exports.OBJECT_KEY_DELIMITER = '-';